import { useEffect, useState } from "react";
import { getProhibitedCountryList } from "../api/country";

// +44 UK instead of Jersey (also UK)
const excludeCountriesCodes = ['je'];

export const useGetProhibitedCountries = () => {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [iso, setIso] = useState(excludeCountriesCodes);

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await getProhibitedCountryList();
                if (res?.data) {
                    setList(res.data.countries);
                    const codes = res.data.isoCodes.map(c => c.toLowerCase())
                    setIso((prev) => prev.concat(codes));
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, []);

    return { list, iso, loading }
}